import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousinB.module.scss";

function PageCousinB() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p31", "jpg", s.content);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);

  return (
    <div className={s.root}>
      <div className={s.aside_left}>
        {imgA}
        <Link to="/cousin/a" className={s.back}>
          {back}
        </Link>
      </div>
      <div className={s.inner}>{content}</div>
    </div>
  );
}

export default withLayoutSimple(PageCousinB, false, false, true, false);
